import { createFileRoute, redirect } from '@tanstack/react-router'
import { bootstrapQueryOptions } from '@/features/bootstrap/api/bootstrap/queries/bootstrap-query'
import {
  getBootstrapWorkspace,
  getBootstrapWorkspaceRefs,
  getWorkspaceEntryRoute,
} from '@/features/bootstrap/domain/bootstrap-workspaces'
import WorkspaceEmptyPage from '@/pages/workspace/workspace-empty'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import { getPreferredWorkspaceRoute } from '@/features/chats/domain/use-workspace-chat-shell-domain'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'
import { redirectToGtmEntry } from '@/shared/lib/gtm-route-guard'

export const Route = createFileRoute('/$lang/workspace/')({
  beforeLoad: async ({ context, params }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      redirectToGtmEntry(context, params)
    }
    requireAuthenticated(context, params)

    const bootstrap = await context.queryClient.ensureQueryData(
      bootstrapQueryOptions(),
    )
    const workspaces = getBootstrapWorkspaceRefs(bootstrap.workspaces)

    if (workspaces.length > 0) {
      const workspaceId = getPreferredWorkspaceRoute(workspaces)
      if (workspaceId) {
        const workspace = getBootstrapWorkspace(workspaces, workspaceId)
        throw redirect({
          to: workspace
            ? getWorkspaceEntryRoute(workspace)
            : '/$lang/workspace/$workspaceId',
          params: { lang: params.lang, workspaceId },
          replace: true,
        })
      }
    }
  },
  component: WorkspaceEmptyPage,
  staticData: { layout: 'main' },
})
